export const NT_REASON = [
  {
    level_1: 'Broadband',
    level_2: [
      {
        title: 'สอบถาม',
        level_3: [
          { title: 'สอบถามอัตราค่าบริการ/ โปรโมชั่น' },
          { title: 'สอบถามพื้นที่ให้บริการ' },
          { title: 'สอบถามเรื่องอุปกรณ์ / การตั้งค่า' },
          { title: 'สอบถามข้อมูลสินค้าและบริการ' },
          { title: 'สอบถามช่องทางสมัครใช้บริการ/จำหน่ายสินค้า' },
          { title: 'สอบถามนัดหมายติดตั้ง' },
          { title: 'สอบถามงานแก้ไขคืนดี' },
          { title: 'สอบถามช่องทางการชำระเงิน' },
          { title: 'สอบถามยอดค้างชำระ/ค่าใช้บริการ/รายละเอียดบิล' },
          { title: 'สอบถามการย้ายค่าย' },
          { title: 'สอบถามข้อมูลองค์กร' },
          { title: 'สอบถามเรื่องอื่น ๆ' }
        ]
      },
      {
        title: 'คำขอบริการ',
        level_3: [
          { title: 'ขอใช้บริการ' },
          { title: 'ขอเปลี่ยนโปรโมชั่น / Package' },
          { title: 'ขอใบแทนใบเสร็จรับเงิน/ใบกำกับภาษี' },
          { title: 'ขอเปลี่ยนแปลงข้อมูลส่วนบุคคล / นิติบุคคล' },
          { title: 'ขอเปลี่ยนวิธีจัดส่งใบแจ้งหนี้ / e-Bill' },
          { title: 'ระงับการใช้ชั่วคราว' },
          { title: 'ขอยกเลิกการระงับการใช้ชั่วคราว' },
          { title: 'คำขอบริการอื่น ๆ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แจ้งเหตุขัดข้อง',
        level_3: [
          { title: 'Disconnect บ่อย' },
          { title: 'Connect ไม่ได้' },
          { title: 'ไม่มีสัญญาณอินเทอร์เน็ต,ไฟสีแดง,ไฟไม่ติด' },
          { title: 'ความเร็วไม่ตรงตามที่ขอ/ Speed ตก' },
          { title: 'เล่นเกมไม่ได้' },
          { title: 'เปิดหน้า Web ไม่ได้ / ออกเว็บบางเว็บไม่ได้' },
          { title: 'เสียนาน / เสียบ่อย' },
          { title: 'รับ-ส่ง Mail ไม่ได้' },
          { title: 'กล่องดูทีวีใช้งานไม่ได้' },
          { title: 'ปัญหาติดตั้งล่าช้า' },
          { title: 'ปัญหาการติดต่อช่างติดตั้ง/ ตรวจแก้' },
          { title: 'ปัญหาลูกค้าถูกตัดสาย' },
          { title: 'Major breakdown' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ใบแจ้งหนี้ / ค่าใช้บริการ',
        level_3: [
          { title: 'ไม่ได้รับใบแจ้งค่าใช้บริการ/ขอสำเนาใบแจ้งค่าใช้บริการ' },
          { title: 'ไม่ได้รับใบเสร็จรับเงิน /ขอสำเนาใบเสร็จรับเงิน' },
          { title: 'ค่าใช้บริการสูงผิดปกติ/ขอตรวจสอบค่าใช้บริการ' },
          { title: 'สมัครบริการ e-service ไม่ได้/ลืม password' },
          { title: 'ชำระเงินผ่านระบบออนไลน์ไม่ได้' },
          { title: 'ชำระเงินแล้ว ยังมียอดค้างชำระ / ยังไม่ต่อสาย' },
          { title: 'แจ้งชำระค่าบริการแล้ว' },
          { title: 'ลูกค้านัดชำระขอให้ต่อสายชั่วคราว' },
          { title: 'ชำระค่าบริการซ้ำ' },
          { title: 'ยกเลิกบริการแล้วแต่ยังได้รับใบแจ้งหนี้' },
          { title: 'ชำระเงินแล้วแต่มีบิลมาเรียกเก็บ' },
          { title: 'ขอรวมบิล / ใบแจ้งค่าใช้บริการ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ร้องเรียนการให้บริการ',
        level_3: [
          { title: 'Call Center' },
          { title: 'ศูนย์บริการ' },
          { title: 'พนักงาน / ช่าง' },
          { title: 'คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ปัญหามิจฉาชีพ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ขอยกเลิกบริการ',
        level_3: [
          { title: 'ยกเลิกคำขอใช้บริการ' },
          { title: 'ยกเลิกการใช้งาน' },
          { title: 'แจ้งเลิกรับ e-Newsletter / SMS' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แนะนำ/ติชม',
        level_3: [
          { title: 'แนะนำบริการของ NT ให้ลูกค้ารายอื่น' },
          { title: 'แนะนำให้ปรับปรุง บริการ' },
          { title: 'แนะนำให้ปรับปรุง อุปกรณ์' },
          { title: 'แนะนำให้ปรับปรุงบริการอื่นๆ' },
          { title: 'ชมเชย Call Center' },
          { title: 'ชมเชย ศูนย์บริการ' },
          { title: 'ชมเชย พนักงาน / ช่าง' },
          { title: 'ชมเชย คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ชมเชยอื่น ๆ' }
        ]
      }
    ]
  },
  {
    level_1: 'ADSL/ VDSL',
    level_2: [
      {
        title: 'สอบถาม',
        level_3: [
          { title: 'สอบถามอัตราค่าบริการ/ โปรโมชั่น' },
          { title: 'สอบถามพื้นที่ให้บริการ' },
          { title: 'สอบถามเรื่องอุปกรณ์ / การตั้งค่า' },
          { title: 'สอบถามข้อมูลสินค้าและบริการ' },
          { title: 'สอบถามช่องทางสมัครใช้บริการ/จำหน่ายสินค้า' },
          { title: 'สอบถามนัดหมายติดตั้ง' },
          { title: 'สอบถามงานแก้ไขคืนดี' },
          { title: 'สอบถามช่องทางการชำระเงิน' },
          { title: 'สอบถามยอดค้างชำระ/ค่าใช้บริการ/รายละเอียดบิล' },
          { title: 'สอบถามการย้ายค่าย' },
          { title: 'สอบถามข้อมูลองค์กร' },
          { title: 'สอบถามเรื่องอื่น ๆ' }
        ]
      },
      {
        title: 'คำขอบริการ',
        level_3: [
          { title: 'ขอใช้บริการ' },
          { title: 'ขอเปลี่ยนโปรโมชั่น / Package' },
          { title: 'ขอใบแทนใบเสร็จรับเงิน/ใบกำกับภาษี' },
          { title: 'ขอเปลี่ยนแปลงข้อมูลส่วนบุคคล / นิติบุคคล' },
          { title: 'ขอเปลี่ยนวิธีจัดส่งใบแจ้งหนี้ / e-Bill' },
          { title: 'ระงับการใช้ชั่วคราว' },
          { title: 'ขอยกเลิกการระงับการใช้ชั่วคราว' },
          { title: 'คำขอบริการอื่น ๆ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แจ้งเหตุขัดข้อง',
        level_3: [
          { title: 'Disconnect บ่อย' },
          { title: 'Connect ไม่ได้' },
          { title: 'ไม่มีสัญญาณอินเทอร์เน็ต,ไฟสีแดง,ไฟไม่ติด' },
          { title: 'ความเร็วไม่ตรงตามที่ขอ/ Speed ตก' },
          { title: 'เล่นเกมไม่ได้' },
          { title: 'เปิดหน้า Web ไม่ได้ / ออกเว็บบางเว็บไม่ได้' },
          { title: 'เสียนาน / เสียบ่อย' },
          { title: 'รับ-ส่ง Mail ไม่ได้' },
          { title: 'กล่องดูทีวีใช้งานไม่ได้' },
          { title: 'ปัญหาติดตั้งล่าช้า' },
          { title: 'ปัญหาการติดต่อช่างติดตั้ง/ ตรวจแก้' },
          { title: 'ปัญหาลูกค้าถูกตัดสาย' },
          { title: 'Major breakdown' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ใบแจ้งหนี้ / ค่าใช้บริการ',
        level_3: [
          { title: 'ไม่ได้รับใบแจ้งค่าใช้บริการ/ขอสำเนาใบแจ้งค่าใช้บริการ' },
          { title: 'ไม่ได้รับใบเสร็จรับเงิน /ขอสำเนาใบเสร็จรับเงิน' },
          { title: 'ค่าใช้บริการสูงผิดปกติ/ขอตรวจสอบค่าใช้บริการ' },
          { title: 'สมัครบริการ e-service ไม่ได้/ลืม password' },
          { title: 'ชำระเงินผ่านระบบออนไลน์ไม่ได้' },
          { title: 'ชำระเงินแล้ว ยังมียอดค้างชำระ / ยังไม่ต่อสาย' },
          { title: 'แจ้งชำระค่าบริการแล้ว' },
          { title: 'ลูกค้านัดชำระขอให้ต่อสายชั่วคราว' },
          { title: 'ชำระค่าบริการซ้ำ' },
          { title: 'ยกเลิกบริการแล้วแต่ยังได้รับใบแจ้งหนี้' },
          { title: 'ชำระเงินแล้วแต่มีบิลมาเรียกเก็บ' },
          { title: 'ขอรวมบิล / ใบแจ้งค่าใช้บริการ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ร้องเรียนการให้บริการ',
        level_3: [
          { title: 'Call Center' },
          { title: 'ศูนย์บริการ' },
          { title: 'พนักงาน / ช่าง' },
          { title: 'คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ปัญหามิจฉาชีพ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ขอยกเลิกบริการ',
        level_3: [
          { title: 'ยกเลิกคำขอใช้บริการ' },
          { title: 'ยกเลิกการใช้งาน' },
          { title: 'แจ้งเลิกรับ e-Newsletter / SMS' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แนะนำ/ติชม',
        level_3: [
          { title: 'แนะนำบริการของ NT ให้ลูกค้ารายอื่น' },
          { title: 'แนะนำให้ปรับปรุง บริการ' },
          { title: 'แนะนำให้ปรับปรุง อุปกรณ์' },
          { title: 'แนะนำให้ปรับปรุงบริการอื่นๆ' },
          { title: 'ชมเชย Call Center' },
          { title: 'ชมเชย ศูนย์บริการ' },
          { title: 'ชมเชย พนักงาน / ช่าง' },
          { title: 'ชมเชย คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ชมเชยอื่น ๆ' }
        ]
      }
    ]
  },
  {
    level_1: 'IP Phone',
    level_2: [
      {
        title: 'สอบถาม',
        level_3: [
          { title: 'สอบถามอัตราค่าบริการ/ โปรโมชั่น' },
          { title: 'สอบถามพื้นที่ให้บริการ' },
          { title: 'สอบถามเรื่องอุปกรณ์ / การตั้งค่า' },
          { title: 'สอบถามข้อมูลสินค้าและบริการ' },
          { title: 'สอบถามช่องทางสมัครใช้บริการ/จำหน่ายสินค้า' },
          { title: 'สอบถามนัดหมายติดตั้ง' },
          { title: 'สอบถามงานแก้ไขคืนดี' },
          { title: 'สอบถามช่องทางการชำระเงิน' },
          { title: 'สอบถามยอดค้างชำระ/ค่าใช้บริการ/รายละเอียดบิล' },
          { title: 'สอบถามการย้ายค่าย' },
          { title: 'สอบถามข้อมูลองค์กร' },
          { title: 'สอบถามเรื่องอื่น ๆ' }
        ]
      },
      {
        title: 'คำขอบริการ',
        level_3: [
          { title: 'ขอใช้บริการ' },
          { title: 'ขอเปลี่ยนโปรโมชั่น / Package' },
          { title: 'ขอใบแทนใบเสร็จรับเงิน/ใบกำกับภาษี' },
          { title: 'ขอเปลี่ยนแปลงข้อมูลส่วนบุคคล / นิติบุคคล' },
          { title: 'ขอเปลี่ยนวิธีจัดส่งใบแจ้งหนี้ / e-Bill' },
          { title: 'ระงับการใช้ชั่วคราว' },
          { title: 'ขอยกเลิกการระงับการใช้ชั่วคราว' },
          { title: 'คำขอบริการอื่น ๆ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แจ้งเหตุขัดข้อง',
        level_3: [
          { title: 'Disconnect บ่อย' },
          { title: 'Connect ไม่ได้' },
          { title: 'ไม่มีสัญญาณอินเทอร์เน็ต,ไฟสีแดง,ไฟไม่ติด' },
          { title: 'เสียนาน / เสียบ่อย' },
          { title: 'แจ้งเสียโทรศัพท์พื้นฐาน' },
          { title: 'ปัญหาติดตั้งล่าช้า' },
          { title: 'ปัญหาการติดต่อช่างติดตั้ง/ ตรวจแก้' },
          { title: 'ปัญหาลูกค้าถูกตัดสาย' },
          { title: 'Major breakdown' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ใบแจ้งหนี้ / ค่าใช้บริการ',
        level_3: [
          { title: 'ไม่ได้รับใบแจ้งค่าใช้บริการ/ขอสำเนาใบแจ้งค่าใช้บริการ' },
          { title: 'ไม่ได้รับใบเสร็จรับเงิน /ขอสำเนาใบเสร็จรับเงิน' },
          { title: 'ค่าใช้บริการสูงผิดปกติ/ขอตรวจสอบค่าใช้บริการ' },
          { title: 'สมัครบริการ e-service ไม่ได้/ลืม password' },
          { title: 'ชำระเงินผ่านระบบออนไลน์ไม่ได้' },
          { title: 'ชำระเงินแล้ว ยังมียอดค้างชำระ / ยังไม่ต่อสาย' },
          { title: 'แจ้งชำระค่าบริการแล้ว' },
          { title: 'ลูกค้านัดชำระขอให้ต่อสายชั่วคราว' },
          { title: 'ชำระค่าบริการซ้ำ' },
          { title: 'ยกเลิกบริการแล้วแต่ยังได้รับใบแจ้งหนี้' },
          { title: 'ชำระเงินแล้วแต่มีบิลมาเรียกเก็บ' },
          { title: 'ขอรวมบิล / ใบแจ้งค่าใช้บริการ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ร้องเรียนการให้บริการ',
        level_3: [
          { title: 'Call Center' },
          { title: 'ศูนย์บริการ' },
          { title: 'พนักงาน / ช่าง' },
          { title: 'คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ปัญหามิจฉาชีพ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ขอยกเลิกบริการ',
        level_3: [
          { title: 'ยกเลิกคำขอใช้บริการ' },
          { title: 'ยกเลิกการใช้งาน' },
          { title: 'ยกเลิกบริการ SPC' },
          { title: 'ยกเลิกแพ็คเกจเหมาจ่ายโทรพื้นฐาน' },
          { title: 'แจ้งเลิกรับ e-Newsletter / SMS' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แนะนำ/ติชม',
        level_3: [
          { title: 'แนะนำบริการของ NT ให้ลูกค้ารายอื่น' },
          { title: 'แนะนำให้ปรับปรุง บริการ' },
          { title: 'แนะนำให้ปรับปรุง อุปกรณ์' },
          { title: 'แนะนำให้ปรับปรุงบริการอื่นๆ' },
          { title: 'ชมเชย Call Center' },
          { title: 'ชมเชย ศูนย์บริการ' },
          { title: 'ชมเชย พนักงาน / ช่าง' },
          { title: 'ชมเชย คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ชมเชยอื่น ๆ' }
        ]
      }
    ]
  },
  {
    level_1: 'Fixed Line',
    level_2: [
      {
        title: 'สอบถาม',
        level_3: [
          { title: 'สอบถามอัตราค่าบริการ/ โปรโมชั่น' },
          { title: 'สอบถามพื้นที่ให้บริการ' },
          { title: 'สอบถามเรื่องอุปกรณ์ / การตั้งค่า' },
          { title: 'สอบถามข้อมูลสินค้าและบริการ' },
          { title: 'สอบถามช่องทางสมัครใช้บริการ/จำหน่ายสินค้า' },
          { title: 'สอบถามนัดหมายติดตั้ง' },
          { title: 'สอบถามงานแก้ไขคืนดี' },
          { title: 'สอบถามช่องทางการชำระเงิน' },
          { title: 'สอบถามยอดค้างชำระ/ค่าใช้บริการ/รายละเอียดบิล' },
          { title: 'สอบถามการย้ายค่าย' },
          { title: 'สอบถามข้อมูลองค์กร' },
          { title: 'สอบถามเรื่องอื่น ๆ' }
        ]
      },
      {
        title: 'คำขอบริการ',
        level_3: [
          { title: 'ขอใช้บริการ' },
          { title: 'ขอเปลี่ยนโปรโมชั่น / Package' },
          { title: 'ขอใบแทนใบเสร็จรับเงิน/ใบกำกับภาษี' },
          { title: 'ขอเปลี่ยนแปลงข้อมูลส่วนบุคคล / นิติบุคคล' },
          { title: 'ขอเปลี่ยนวิธีจัดส่งใบแจ้งหนี้ / e-Bill' },
          { title: 'ระงับการใช้ชั่วคราว' },
          { title: 'ขอยกเลิกการระงับการใช้ชั่วคราว' },
          { title: 'คำขอบริการอื่น ๆ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แจ้งเหตุขัดข้อง',
        level_3: [
          { title: 'เสียนาน / เสียบ่อย' },
          { title: 'แจ้งเสียโทรศัพท์พื้นฐาน' },
          { title: 'ปัญหาติดตั้งล่าช้า' },
          { title: 'ปัญหาการติดต่อช่างติดตั้ง/ ตรวจแก้' },
          { title: 'ปัญหาลูกค้าถูกตัดสาย' },
          { title: 'Major breakdown' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ใบแจ้งหนี้ / ค่าใช้บริการ',
        level_3: [
          { title: 'ไม่ได้รับใบแจ้งค่าใช้บริการ/ขอสำเนาใบแจ้งค่าใช้บริการ' },
          { title: 'ไม่ได้รับใบเสร็จรับเงิน /ขอสำเนาใบเสร็จรับเงิน' },
          { title: 'ค่าใช้บริการสูงผิดปกติ/ขอตรวจสอบค่าใช้บริการ' },
          { title: 'สมัครบริการ e-service ไม่ได้/ลืม password' },
          { title: 'ชำระเงินผ่านระบบออนไลน์ไม่ได้' },
          { title: 'ชำระเงินแล้ว ยังมียอดค้างชำระ / ยังไม่ต่อสาย' },
          { title: 'แจ้งชำระค่าบริการแล้ว' },
          { title: 'ลูกค้านัดชำระขอให้ต่อสายชั่วคราว' },
          { title: 'ชำระค่าบริการซ้ำ' },
          { title: 'ยกเลิกบริการแล้วแต่ยังได้รับใบแจ้งหนี้' },
          { title: 'ชำระเงินแล้วแต่มีบิลมาเรียกเก็บ' },
          { title: 'ขอรวมบิล / ใบแจ้งค่าใช้บริการ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ร้องเรียนการให้บริการ',
        level_3: [
          { title: 'Call Center' },
          { title: 'ศูนย์บริการ' },
          { title: 'พนักงาน / ช่าง' },
          { title: 'คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ปัญหามิจฉาชีพ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ขอยกเลิกบริการ',
        level_3: [
          { title: 'ยกเลิกคำขอใช้บริการ' },
          { title: 'ยกเลิกการใช้งาน' },
          { title: 'ยกเลิกบริการ SPC' },
          { title: 'ยกเลิกแพ็คเกจเหมาจ่ายโทรพื้นฐาน' },
          { title: 'แจ้งเลิกรับ e-Newsletter / SMS' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แนะนำ/ติชม',
        level_3: [
          { title: 'แนะนำบริการของ NT ให้ลูกค้ารายอื่น' },
          { title: 'แนะนำให้ปรับปรุง บริการ' },
          { title: 'แนะนำให้ปรับปรุง อุปกรณ์' },
          { title: 'แนะนำให้ปรับปรุงบริการอื่นๆ' },
          { title: 'ชมเชย Call Center' },
          { title: 'ชมเชย ศูนย์บริการ' },
          { title: 'ชมเชย พนักงาน / ช่าง' },
          { title: 'ชมเชย คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ชมเชยอื่น ๆ' }
        ]
      }
    ]
  },
  {
    level_1: 'Mobile / MY',
    level_2: [
      {
        title: 'สอบถาม',
        level_3: [
          { title: 'สอบถามอัตราค่าบริการ/ โปรโมชั่น' },
          { title: 'สอบถามพื้นที่ให้บริการ' },
          { title: 'สอบถามเรื่องอุปกรณ์ / การตั้งค่า' },
          { title: 'สอบถามข้อมูลสินค้าและบริการ' },
          { title: 'สอบถามช่องทางสมัครใช้บริการ/จำหน่ายสินค้า' },
          { title: 'สอบถามงานแก้ไขคืนดี' },
          { title: 'สอบถามช่องทางการชำระเงิน' },
          { title: 'สอบถามยอดค้างชำระ/ค่าใช้บริการ/รายละเอียดบิล' },
          { title: 'สอบถามการย้ายค่าย' },
          { title: 'สอบถามข้อมูลองค์กร' },
          { title: 'สอบถามเรื่องอื่น ๆ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'คำขอบริการ',
        level_3: [
          { title: 'ขอใช้บริการ' },
          { title: 'ขอเปลี่ยนโปรโมชั่น / Package' },
          { title: 'ขอใบแทนใบเสร็จรับเงิน/ใบกำกับภาษี' },
          { title: 'ขอเปลี่ยนแปลงข้อมูลส่วนบุคคล / นิติบุคคล' },
          { title: 'ขอเปลี่ยนวิธีจัดส่งใบแจ้งหนี้ / e-Bill' },
          { title: 'ระงับการใช้ชั่วคราว' },
          { title: 'ขอยกเลิกการระงับการใช้ชั่วคราว' },
          { title: 'คำขอบริการอื่น ๆ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แจ้งเหตุขัดข้อง',
        level_3: [
          { title: 'เล่นเกมไม่ได้' },
          { title: 'เปิดหน้า Web ไม่ได้ / ออกเว็บบางเว็บไม่ได้' },
          { title: 'เสียนาน / เสียบ่อย' },
          { title: 'รับ-ส่ง Mail ไม่ได้' },
          { title: 'ปัญหาการรับสัญญาณ 3G/4G/5G' },
          { title: 'ปัญหาการใช้เว็บเติมเงิน (Prepaid e-Service)' },
          { title: 'ปัญหาการติดต่อช่างติดตั้ง/ ตรวจแก้' },
          { title: 'ปัญหาลูกค้าถูกตัดสาย' },
          { title: 'Major breakdown' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ใบแจ้งหนี้ / ค่าใช้บริการ',
        level_3: [
          { title: 'ไม่ได้รับใบแจ้งค่าใช้บริการ/ขอสำเนาใบแจ้งค่าใช้บริการ' },
          { title: 'ไม่ได้รับใบเสร็จรับเงิน /ขอสำเนาใบเสร็จรับเงิน' },
          { title: 'ค่าใช้บริการสูงผิดปกติ/ขอตรวจสอบค่าใช้บริการ' },
          { title: 'สมัครบริการ e-service ไม่ได้/ลืม password' },
          { title: 'ชำระเงินผ่านระบบออนไลน์ไม่ได้' },
          { title: 'ชำระเงินแล้ว ยังมียอดค้างชำระ / ยังไม่ต่อสาย' },
          { title: 'แจ้งชำระค่าบริการแล้ว' },
          { title: 'ลูกค้านัดชำระขอให้ต่อสายชั่วคราว' },
          { title: 'ชำระค่าบริการซ้ำ' },
          { title: 'ยกเลิกบริการแล้วแต่ยังได้รับใบแจ้งหนี้' },
          { title: 'ชำระเงินแล้วแต่มีบิลมาเรียกเก็บ' },
          { title: 'ขอรวมบิล / ใบแจ้งค่าใช้บริการ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ร้องเรียนการให้บริการ',
        level_3: [
          { title: 'Call Center' },
          { title: 'ศูนย์บริการ' },
          { title: 'พนักงาน / ช่าง' },
          { title: 'คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ปัญหามิจฉาชีพ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ขอยกเลิกบริการ',
        level_3: [
          { title: 'ยกเลิกคำขอใช้บริการ' },
          { title: 'ยกเลิกการใช้งาน' },
          { title: 'แจ้งเลิกรับ e-Newsletter / SMS' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แนะนำ/ติชม',
        level_3: [
          { title: 'แนะนำบริการของ NT ให้ลูกค้ารายอื่น' },
          { title: 'แนะนำให้ปรับปรุง บริการ' },
          { title: 'แนะนำให้ปรับปรุง อุปกรณ์' },
          { title: 'แนะนำให้ปรับปรุงบริการอื่นๆ' },
          { title: 'ชมเชย Call Center' },
          { title: 'ชมเชย ศูนย์บริการ' },
          { title: 'ชมเชย พนักงาน / ช่าง' },
          { title: 'ชมเชย คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ชมเชยอื่น ๆ' }
        ]
      }
    ]
  },
  {
    level_1: 'Wireless net',
    level_2: [
      {
        title: 'สอบถาม',
        level_3: [
          { title: 'สอบถามอัตราค่าบริการ/ โปรโมชั่น' },
          { title: 'สอบถามพื้นที่ให้บริการ' },
          { title: 'สอบถามเรื่องอุปกรณ์ / การตั้งค่า' },
          { title: 'สอบถามข้อมูลสินค้าและบริการ' },
          { title: 'สอบถามช่องทางสมัครใช้บริการ/จำหน่ายสินค้า' },
          { title: 'สอบถามนัดหมายติดตั้ง' },
          { title: 'สอบถามงานแก้ไขคืนดี' },
          { title: 'สอบถามช่องทางการชำระเงิน' },
          { title: 'สอบถามยอดค้างชำระ/ค่าใช้บริการ/รายละเอียดบิล' },
          { title: 'สอบถามการย้ายค่าย' },
          { title: 'สอบถามข้อมูลองค์กร' },
          { title: 'สอบถามเรื่องอื่น ๆ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'คำขอบริการ',
        level_3: [
          { title: 'ขอใช้บริการ' },
          { title: 'ขอเปลี่ยนโปรโมชั่น / Package' },
          { title: 'ขอใบแทนใบเสร็จรับเงิน/ใบกำกับภาษี' },
          { title: 'ขอเปลี่ยนแปลงข้อมูลส่วนบุคคล / นิติบุคคล' },
          { title: 'ขอเปลี่ยนวิธีจัดส่งใบแจ้งหนี้ / e-Bill' },
          { title: 'ระงับการใช้ชั่วคราว' },
          { title: 'ขอยกเลิกการระงับการใช้ชั่วคราว' },
          { title: 'คำขอบริการอื่น ๆ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แจ้งเหตุขัดข้อง',
        level_3: [
          { title: 'เล่นเกมไม่ได้' },
          { title: 'เปิดหน้า Web ไม่ได้ / ออกเว็บบางเว็บไม่ได้' },
          { title: 'เสียนาน / เสียบ่อย' },
          { title: 'รับ-ส่ง Mail ไม่ได้' },
          { title: 'ปัญหาการรับสัญญาณ 3G/4G/5G' },
          { title: 'ปัญหาการติดต่อช่างติดตั้ง/ ตรวจแก้' },
          { title: 'ปัญหาลูกค้าถูกตัดสาย' },
          { title: 'Major breakdown' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ใบแจ้งหนี้ / ค่าใช้บริการ',
        level_3: [
          { title: 'ไม่ได้รับใบแจ้งค่าใช้บริการ/ขอสำเนาใบแจ้งค่าใช้บริการ' },
          { title: 'ไม่ได้รับใบเสร็จรับเงิน /ขอสำเนาใบเสร็จรับเงิน' },
          { title: 'ค่าใช้บริการสูงผิดปกติ/ขอตรวจสอบค่าใช้บริการ' },
          { title: 'สมัครบริการ e-service ไม่ได้/ลืม password' },
          { title: 'ชำระเงินผ่านระบบออนไลน์ไม่ได้' },
          { title: 'ชำระเงินแล้ว ยังมียอดค้างชำระ / ยังไม่ต่อสาย' },
          { title: 'แจ้งชำระค่าบริการแล้ว' },
          { title: 'ลูกค้านัดชำระขอให้ต่อสายชั่วคราว' },
          { title: 'ชำระค่าบริการซ้ำ' },
          { title: 'ยกเลิกบริการแล้วแต่ยังได้รับใบแจ้งหนี้' },
          { title: 'ชำระเงินแล้วแต่มีบิลมาเรียกเก็บ' },
          { title: 'ขอรวมบิล / ใบแจ้งค่าใช้บริการ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ร้องเรียนการให้บริการ',
        level_3: [
          { title: 'Call Center' },
          { title: 'ศูนย์บริการ' },
          { title: 'พนักงาน / ช่าง' },
          { title: 'คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ปัญหามิจฉาชีพ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ขอยกเลิกบริการ',
        level_3: [
          { title: 'ยกเลิกคำขอใช้บริการ' },
          { title: 'ยกเลิกการใช้งาน' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แนะนำ/ติชม',
        level_3: [
          { title: 'แนะนำบริการของ NT ให้ลูกค้ารายอื่น' },
          { title: 'แนะนำให้ปรับปรุง บริการ' },
          { title: 'แนะนำให้ปรับปรุง อุปกรณ์' },
          { title: 'แนะนำให้ปรับปรุงบริการอื่นๆ' },
          { title: 'ชมเชย Call Center' },
          { title: 'ชมเชย ศูนย์บริการ' },
          { title: 'ชมเชย พนักงาน / ช่าง' },
          { title: 'ชมเชย คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ชมเชยอื่น ๆ' }
        ]
      }
    ]
  },
  {
    level_1: 'Winet',
    level_2: [
      {
        title: 'สอบถาม',
        level_3: [
          { title: 'สอบถามอัตราค่าบริการ/ โปรโมชั่น' },
          { title: 'สอบถามพื้นที่ให้บริการ' },
          { title: 'สอบถามเรื่องอุปกรณ์ / การตั้งค่า' },
          { title: 'สอบถามข้อมูลสินค้าและบริการ' },
          { title: 'สอบถามช่องทางสมัครใช้บริการ/จำหน่ายสินค้า' },
          { title: 'สอบถามนัดหมายติดตั้ง' },
          { title: 'สอบถามงานแก้ไขคืนดี' },
          { title: 'สอบถามช่องทางการชำระเงิน' },
          { title: 'สอบถามยอดค้างชำระ/ค่าใช้บริการ/รายละเอียดบิล' },
          { title: 'สอบถามการย้ายค่าย' },
          { title: 'สอบถามข้อมูลองค์กร' },
          { title: 'สอบถามเรื่องอื่น ๆ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'คำขอบริการ',
        level_3: [
          { title: 'ขอใช้บริการ' },
          { title: 'ขอเปลี่ยนโปรโมชั่น / Package' },
          { title: 'ขอใบแทนใบเสร็จรับเงิน/ใบกำกับภาษี' },
          { title: 'ขอเปลี่ยนแปลงข้อมูลส่วนบุคคล / นิติบุคคล' },
          { title: 'ขอเปลี่ยนวิธีจัดส่งใบแจ้งหนี้ / e-Bill' },
          { title: 'ระงับการใช้ชั่วคราว' },
          { title: 'ขอยกเลิกการระงับการใช้ชั่วคราว' },
          { title: 'คำขอบริการอื่น ๆ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แจ้งเหตุขัดข้อง',
        level_3: [
          { title: 'Disconnect บ่อย' },
          { title: 'Connect ไม่ได้' },
          { title: 'ไม่มีสัญญาณอินเทอร์เน็ต,ไฟสีแดง,ไฟไม่ติด' },
          { title: 'ความเร็วไม่ตรงตามที่ขอ/ Speed ตก' },
          { title: 'เล่นเกมไม่ได้' },
          { title: 'เปิดหน้า Web ไม่ได้ / ออกเว็บบางเว็บไม่ได้' },
          { title: 'เสียนาน / เสียบ่อย' },
          { title: 'รับ-ส่ง Mail ไม่ได้' },
          { title: 'ปัญหาการติดต่อช่างติดตั้ง/ ตรวจแก้' },
          { title: 'ปัญหาลูกค้าถูกตัดสาย' },
          { title: 'Major breakdown' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ใบแจ้งหนี้ / ค่าใช้บริการ',
        level_3: [
          { title: 'ไม่ได้รับใบแจ้งค่าใช้บริการ/ขอสำเนาใบแจ้งค่าใช้บริการ' },
          { title: 'ไม่ได้รับใบเสร็จรับเงิน /ขอสำเนาใบเสร็จรับเงิน' },
          { title: 'ค่าใช้บริการสูงผิดปกติ/ขอตรวจสอบค่าใช้บริการ' },
          { title: 'สมัครบริการ e-service ไม่ได้/ลืม password' },
          { title: 'ชำระเงินผ่านระบบออนไลน์ไม่ได้' },
          { title: 'ชำระเงินแล้ว ยังมียอดค้างชำระ / ยังไม่ต่อสาย' },
          { title: 'แจ้งชำระค่าบริการแล้ว' },
          { title: 'ลูกค้านัดชำระขอให้ต่อสายชั่วคราว' },
          { title: 'ชำระค่าบริการซ้ำ' },
          { title: 'ยกเลิกบริการแล้วแต่ยังได้รับใบแจ้งหนี้' },
          { title: 'ชำระเงินแล้วแต่มีบิลมาเรียกเก็บ' },
          { title: 'ขอรวมบิล / ใบแจ้งค่าใช้บริการ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ร้องเรียนการให้บริการ',
        level_3: [
          { title: 'Call Center' },
          { title: 'ศูนย์บริการ' },
          { title: 'พนักงาน / ช่าง' },
          { title: 'คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ปัญหามิจฉาชีพ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ขอยกเลิกบริการ',
        level_3: [
          { title: 'ยกเลิกคำขอใช้บริการ' },
          { title: 'ยกเลิกการใช้งาน' },
          { title: 'แจ้งเลิกรับ e-Newsletter / SMS' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แนะนำ/ติชม',
        level_3: [
          { title: 'แนะนำบริการของ NT ให้ลูกค้ารายอื่น' },
          { title: 'แนะนำให้ปรับปรุง บริการ' },
          { title: 'แนะนำให้ปรับปรุง อุปกรณ์' },
          { title: 'แนะนำให้ปรับปรุงบริการอื่นๆ' },
          { title: 'ชมเชย Call Center' },
          { title: 'ชมเชย ศูนย์บริการ' },
          { title: 'ชมเชย พนักงาน / ช่าง' },
          { title: 'ชมเชย คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ชมเชยอื่น ๆ' }
        ]
      }
    ]
  },
  {
    level_1: 'IPTV/ C-nema',
    level_2: [
      {
        title: 'สอบถาม',
        level_3: [
          { title: 'สอบถามอัตราค่าบริการ/ โปรโมชั่น' },
          { title: 'สอบถามพื้นที่ให้บริการ' },
          { title: 'สอบถามเรื่องอุปกรณ์ / การตั้งค่า' },
          { title: 'สอบถามข้อมูลสินค้าและบริการ' },
          { title: 'สอบถามช่องทางสมัครใช้บริการ/จำหน่ายสินค้า' },
          { title: 'สอบถามนัดหมายติดตั้ง' },
          { title: 'สอบถามงานแก้ไขคืนดี' },
          { title: 'สอบถามช่องทางการชำระเงิน' },
          { title: 'สอบถามยอดค้างชำระ/ค่าใช้บริการ/รายละเอียดบิล' },
          { title: 'สอบถามการย้ายค่าย' },
          { title: 'สอบถามข้อมูลองค์กร' },
          { title: 'สอบถามเรื่องอื่น ๆ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'คำขอบริการ',
        level_3: [
          { title: 'ขอใช้บริการ' },
          { title: 'ขอเปลี่ยนโปรโมชั่น / Package' },
          { title: 'ขอใบแทนใบเสร็จรับเงิน/ใบกำกับภาษี' },
          { title: 'ขอเปลี่ยนแปลงข้อมูลส่วนบุคคล / นิติบุคคล' },
          { title: 'ขอเปลี่ยนวิธีจัดส่งใบแจ้งหนี้ / e-Bill' },
          { title: 'ระงับการใช้ชั่วคราว' },
          { title: 'ขอยกเลิกการระงับการใช้ชั่วคราว' },
          { title: 'คำขอบริการอื่น ๆ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แจ้งเหตุขัดข้อง',
        level_3: [
          { title: 'Disconnect บ่อย' },
          { title: 'Connect ไม่ได้' },
          { title: 'ไม่มีสัญญาณอินเทอร์เน็ต,ไฟสีแดง,ไฟไม่ติด' },
          { title: 'เสียนาน / เสียบ่อย' },
          { title: 'กล่องดูทีวีใช้งานไม่ได้' },
          { title: 'ปัญหาติดตั้งล่าช้า' },
          { title: 'ปัญหาการติดต่อช่างติดตั้ง/ ตรวจแก้' },
          { title: 'ปัญหาลูกค้าถูกตัดสาย' },
          { title: 'Major breakdown' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ใบแจ้งหนี้ / ค่าใช้บริการ',
        level_3: [
          { title: 'ไม่ได้รับใบแจ้งค่าใช้บริการ/ขอสำเนาใบแจ้งค่าใช้บริการ' },
          { title: 'ไม่ได้รับใบเสร็จรับเงิน /ขอสำเนาใบเสร็จรับเงิน' },
          { title: 'ค่าใช้บริการสูงผิดปกติ/ขอตรวจสอบค่าใช้บริการ' },
          { title: 'สมัครบริการ e-service ไม่ได้/ลืม password' },
          { title: 'ชำระเงินผ่านระบบออนไลน์ไม่ได้' },
          { title: 'ชำระเงินแล้ว ยังมียอดค้างชำระ / ยังไม่ต่อสาย' },
          { title: 'แจ้งชำระค่าบริการแล้ว' },
          { title: 'ลูกค้านัดชำระขอให้ต่อสายชั่วคราว' },
          { title: 'ชำระค่าบริการซ้ำ' },
          { title: 'ยกเลิกบริการแล้วแต่ยังได้รับใบแจ้งหนี้' },
          { title: 'ชำระเงินแล้วแต่มีบิลมาเรียกเก็บ' },
          { title: 'ขอรวมบิล / ใบแจ้งค่าใช้บริการ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ร้องเรียนการให้บริการ',
        level_3: [
          { title: 'Call Center' },
          { title: 'ศูนย์บริการ' },
          { title: 'พนักงาน / ช่าง' },
          { title: 'คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ปัญหามิจฉาชีพ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ขอยกเลิกบริการ',
        level_3: [
          { title: 'ยกเลิกคำขอใช้บริการ' },
          { title: 'ยกเลิกการใช้งาน' },
          { title: 'แจ้งเลิกรับ e-Newsletter / SMS' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แนะนำ/ติชม',
        level_3: [
          { title: 'แนะนำบริการของ NT ให้ลูกค้ารายอื่น' },
          { title: 'แนะนำให้ปรับปรุง บริการ' },
          { title: 'แนะนำให้ปรับปรุง อุปกรณ์' },
          { title: 'แนะนำให้ปรับปรุงบริการอื่นๆ' },
          { title: 'ชมเชย Call Center' },
          { title: 'ชมเชย ศูนย์บริการ' },
          { title: 'ชมเชย พนักงาน / ช่าง' },
          { title: 'ชมเชย คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ชมเชยอื่น ๆ' }
        ]
      }
    ]
  },
  {
    level_1: 'โทรต่างประเทศ',
    level_2: [
      {
        title: 'สอบถาม',
        level_3: [
          { title: 'สอบถามอัตราค่าบริการ/ โปรโมชั่น' },
          { title: 'สอบถามพื้นที่ให้บริการ' },
          { title: 'สอบถามเรื่องอุปกรณ์ / การตั้งค่า' },
          { title: 'สอบถามข้อมูลสินค้าและบริการ' },
          { title: 'สอบถามช่องทางสมัครใช้บริการ/จำหน่ายสินค้า' },
          { title: 'สอบถามงานแก้ไขคืนดี' },
          { title: 'สอบถามช่องทางการชำระเงิน' },
          { title: 'สอบถามยอดค้างชำระ/ค่าใช้บริการ/รายละเอียดบิล' },
          { title: 'สอบถามข้อมูลองค์กร' },
          { title: 'สอบถามเรื่องอื่น ๆ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'คำขอบริการ',
        level_3: [
          { title: 'ขอใช้บริการ' },
          { title: 'ขอเปลี่ยนโปรโมชั่น / Package' },
          { title: 'ขอใบแทนใบเสร็จรับเงิน/ใบกำกับภาษี' },
          { title: 'ขอเปลี่ยนแปลงข้อมูลส่วนบุคคล / นิติบุคคล' },
          { title: 'ขอเปลี่ยนวิธีจัดส่งใบแจ้งหนี้ / e-Bill' },
          { title: 'ระงับการใช้ชั่วคราว' },
          { title: 'ขอยกเลิกการระงับการใช้ชั่วคราว' },
          { title: 'คำขอบริการอื่น ๆ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แจ้งเหตุขัดข้อง',
        level_3: [
          { title: 'เสียนาน / เสียบ่อย' },
          { title: 'แจ้งเสียโทรศัพท์พื้นฐาน' },
          { title: 'ปัญหาการติดต่อช่างติดตั้ง/ ตรวจแก้' },
          { title: 'ปัญหาลูกค้าถูกตัดสาย' },
          { title: 'Major breakdown' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ใบแจ้งหนี้ / ค่าใช้บริการ',
        level_3: [
          { title: 'ไม่ได้รับใบแจ้งค่าใช้บริการ/ขอสำเนาใบแจ้งค่าใช้บริการ' },
          { title: 'ไม่ได้รับใบเสร็จรับเงิน /ขอสำเนาใบเสร็จรับเงิน' },
          { title: 'ค่าใช้บริการสูงผิดปกติ/ขอตรวจสอบค่าใช้บริการ' },
          { title: 'สมัครบริการ e-service ไม่ได้/ลืม password' },
          { title: 'ชำระเงินผ่านระบบออนไลน์ไม่ได้' },
          { title: 'ชำระเงินแล้ว ยังมียอดค้างชำระ / ยังไม่ต่อสาย' },
          { title: 'แจ้งชำระค่าบริการแล้ว' },
          { title: 'ลูกค้านัดชำระขอให้ต่อสายชั่วคราว' },
          { title: 'ชำระค่าบริการซ้ำ' },
          { title: 'ยกเลิกบริการแล้วแต่ยังได้รับใบแจ้งหนี้' },
          { title: 'ชำระเงินแล้วแต่มีบิลมาเรียกเก็บ' },
          { title: 'ขอรวมบิล / ใบแจ้งค่าใช้บริการ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ร้องเรียนการให้บริการ',
        level_3: [
          { title: 'Call Center' },
          { title: 'ศูนย์บริการ' },
          { title: 'พนักงาน / ช่าง' },
          { title: 'คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ปัญหามิจฉาชีพ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ขอยกเลิกบริการ',
        level_3: [
          { title: 'ยกเลิกคำขอใช้บริการ' },
          { title: 'ยกเลิกการใช้งาน' },
          { title: 'แจ้งเลิกรับ e-Newsletter / SMS' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แนะนำ/ติชม',
        level_3: [
          { title: 'แนะนำบริการของ NT ให้ลูกค้ารายอื่น' },
          { title: 'แนะนำให้ปรับปรุง บริการ' },
          { title: 'แนะนำให้ปรับปรุง อุปกรณ์' },
          { title: 'แนะนำให้ปรับปรุงบริการอื่นๆ' },
          { title: 'ชมเชย Call Center' },
          { title: 'ชมเชย ศูนย์บริการ' },
          { title: 'ชมเชย พนักงาน / ช่าง' },
          { title: 'ชมเชย คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ชมเชยอื่น ๆ' }
        ]
      }
    ]
  },
  {
    level_1: 'Privilege',
    level_2: [
      {
        title: 'สอบถาม',
        level_3: [
          { title: 'สอบถามข้อมูลสินค้าและบริการ' },
          { title: 'สอบถามช่องทางสมัครใช้บริการ/จำหน่ายสินค้า' },
          { title: 'สอบถามช่องทางการชำระเงิน' },
          { title: 'สอบถามยอดค้างชำระ/ค่าใช้บริการ/รายละเอียดบิล' },
          { title: 'สอบถามข้อมูลองค์กร' },
          { title: 'สอบถามวิธีสะสมแต้ม/แลกแต้ม/เช็กแต้มคงเหลือ/แต้มหมดอายุ' },
          { title: 'สอบถามเรื่องอื่น ๆ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'คำขอบริการ',
        level_3: [
          { title: 'ขอใช้บริการ' },
          { title: 'ขอใบแทนใบเสร็จรับเงิน/ใบกำกับภาษี' },
          { title: 'ขอเปลี่ยนแปลงข้อมูลส่วนบุคคล / นิติบุคคล' },
          { title: 'คำขอบริการอื่น ๆ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แจ้งเหตุขัดข้อง',
        level_3: [{ title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }]
      },
      {
        title: 'ใบแจ้งหนี้ / ค่าใช้บริการ',
        level_3: [{ title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }]
      },
      {
        title: 'ร้องเรียนการให้บริการ',
        level_3: [
          { title: 'Call Center' },
          { title: 'ศูนย์บริการ' },
          { title: 'พนักงาน / ช่าง' },
          { title: 'คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ปัญหามิจฉาชีพ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ขอยกเลิกบริการ',
        level_3: [
          { title: 'ยกเลิกคำขอใช้บริการ' },
          { title: 'ยกเลิกการใช้งาน' },
          { title: 'แจ้งเลิกรับ e-Newsletter / SMS' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แนะนำ/ติชม',
        level_3: [
          { title: 'แนะนำบริการของ NT ให้ลูกค้ารายอื่น' },
          { title: 'แนะนำให้ปรับปรุง บริการ' },
          { title: 'แนะนำให้ปรับปรุง อุปกรณ์' },
          { title: 'แนะนำให้ปรับปรุงบริการอื่นๆ' },
          { title: 'ชมเชย Call Center' },
          { title: 'ชมเชย ศูนย์บริการ' },
          { title: 'ชมเชย พนักงาน / ช่าง' },
          { title: 'ชมเชย คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ชมเชยอื่น ๆ' }
        ]
      }
    ]
  },
  {
    level_1: 'โครงสร้างพื้นฐาน',
    level_2: [
      {
        title: 'สอบถาม',
        level_3: [
          { title: 'สอบถามพื้นที่ให้บริการ' },
          { title: 'สอบถามงานโครงสร้างพื้นฐาน' },
          { title: 'สอบถามข้อมูลองค์กร' },
          { title: 'สอบถามเรื่องอื่น ๆ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'คำขอบริการ',
        level_3: [
          { title: 'ขอใช้บริการ' },
          { title: 'คำขอบริการอื่น ๆ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แจ้งเหตุขัดข้อง',
        level_3: [{ title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }]
      },
      {
        title: 'ใบแจ้งหนี้ / ค่าใช้บริการ',
        level_3: [{ title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }]
      },
      {
        title: 'ปัญหาโครงสร้างพื้นฐาน',
        level_3: [
          { title: 'ย้ายตู้โทรศัพท์สาธารณะ / ตู้ผ่าน' },
          { title: 'สายสัญญาณ' },
          { title: 'เสาสัญญาณ' },
          { title: 'ฝาท่อร้อยสาย/ ฝาบ่อพัก' },
          { title: 'ปัญหาด้านอื่น ๆ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ร้องเรียนการให้บริการ',
        level_3: [
          { title: 'Call Center' },
          { title: 'ศูนย์บริการ' },
          { title: 'พนักงาน / ช่าง' },
          { title: 'คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ปัญหามิจฉาชีพ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ขอยกเลิกบริการ',
        level_3: [{ title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }]
      },
      {
        title: 'แนะนำ/ติชม',
        level_3: [
          { title: 'แนะนำบริการของ NT ให้ลูกค้ารายอื่น' },
          { title: 'แนะนำให้ปรับปรุง บริการ' },
          { title: 'แนะนำให้ปรับปรุง อุปกรณ์' },
          { title: 'แนะนำให้ปรับปรุงบริการอื่นๆ' },
          { title: 'ชมเชย Call Center' },
          { title: 'ชมเชย ศูนย์บริการ' },
          { title: 'ชมเชย พนักงาน / ช่าง' },
          { title: 'ชมเชย คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ชมเชยอื่น ๆ' }
        ]
      }
    ]
  },
  {
    level_1: 'NT eService',
    level_2: [
      {
        title: 'สอบถาม',
        level_3: [
          { title: 'สอบถามช่องทางการชำระเงิน' },
          { title: 'สอบถามยอดค้างชำระ/ค่าใช้บริการ/รายละเอียดบิล' },
          { title: 'สอบถามวิธีสะสมแต้ม/แลกแต้ม/เช็กแต้มคงเหลือ/แต้มหมดอายุ' },
          { title: 'สอบถามบริการ NT eService' },
          { title: 'สอบถามเรื่องอื่น ๆ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'คำขอบริการ',
        level_3: [
          { title: 'ขอใช้บริการ' },
          { title: 'ขอเปลี่ยนโปรโมชั่น / Package' },
          { title: 'ขอเปลี่ยนแปลงข้อมูลส่วนบุคคล / นิติบุคคล' },
          { title: 'ขอเปลี่ยนวิธีจัดส่งใบแจ้งหนี้ / e-Bill' },
          { title: 'คำขอบริการอื่น ๆ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แจ้งเหตุขัดข้อง',
        level_3: [{ title: 'Major breakdown' }, { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }]
      },
      {
        title: 'ใบแจ้งหนี้ / ค่าใช้บริการ',
        level_3: [
          { title: 'ไม่ได้รับใบแจ้งค่าใช้บริการ/ขอสำเนาใบแจ้งค่าใช้บริการ' },
          { title: 'ไม่ได้รับใบเสร็จรับเงิน /ขอสำเนาใบเสร็จรับเงิน' },
          { title: 'ค่าใช้บริการสูงผิดปกติ/ขอตรวจสอบค่าใช้บริการ' },
          { title: 'สมัครบริการ e-service ไม่ได้/ลืม password' },
          { title: 'ชำระเงินผ่านระบบออนไลน์ไม่ได้' },
          { title: 'ชำระเงินแล้ว ยังมียอดค้างชำระ / ยังไม่ต่อสาย' },
          { title: 'แจ้งชำระค่าบริการแล้ว' },
          { title: 'ลูกค้านัดชำระขอให้ต่อสายชั่วคราว' },
          { title: 'ชำระค่าบริการซ้ำ' },
          { title: 'ยกเลิกบริการแล้วแต่ยังได้รับใบแจ้งหนี้' },
          { title: 'ชำระเงินแล้วแต่มีบิลมาเรียกเก็บ' },
          { title: 'ขอรวมบิล / ใบแจ้งค่าใช้บริการ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ร้องเรียนการให้บริการ',
        level_3: [
          { title: 'Call Center' },
          { title: 'ศูนย์บริการ' },
          { title: 'พนักงาน / ช่าง' },
          { title: 'คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ปัญหามิจฉาชีพ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ขอยกเลิกบริการ',
        level_3: [
          { title: 'ยกเลิกคำขอใช้บริการ' },
          { title: 'ยกเลิกการใช้งาน' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แนะนำ/ติชม',
        level_3: [
          { title: 'แนะนำบริการของ NT ให้ลูกค้ารายอื่น' },
          { title: 'แนะนำให้ปรับปรุง บริการ' },
          { title: 'แนะนำให้ปรับปรุง อุปกรณ์' },
          { title: 'แนะนำให้ปรับปรุงบริการอื่นๆ' },
          { title: 'ชมเชย Call Center' },
          { title: 'ชมเชย ศูนย์บริการ' },
          { title: 'ชมเชย พนักงาน / ช่าง' },
          { title: 'ชมเชย คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ชมเชยอื่น ๆ' }
        ]
      }
    ]
  },
  {
    level_1: 'NT Easy Life',
    level_2: [
      {
        title: 'สอบถาม',
        level_3: [
          { title: 'สอบถามช่องทางการชำระเงิน' },
          { title: 'สอบถามยอดค้างชำระ/ค่าใช้บริการ/รายละเอียดบิล' },
          { title: 'สอบถามบริการ NT Easy Life' },
          { title: 'สอบถามเรื่องอื่น ๆ' }
        ]
      },
      {
        title: 'คำขอบริการ',
        level_3: [
          { title: 'ขอใช้บริการ' },
          { title: 'ขอเปลี่ยนโปรโมชั่น / Package' },
          { title: 'ขอเปลี่ยนวิธีจัดส่งใบแจ้งหนี้ / e-Bill' },
          { title: 'คำขอบริการอื่น ๆ' }
        ]
      },
      {
        title: 'แจ้งเหตุขัดข้อง',
        level_3: [{ title: 'Major breakdown' }, { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }]
      },
      {
        title: 'ใบแจ้งหนี้ / ค่าใช้บริการ',
        level_3: [
          { title: 'ไม่ได้รับใบแจ้งค่าใช้บริการ/ขอสำเนาใบแจ้งค่าใช้บริการ' },
          { title: 'ไม่ได้รับใบเสร็จรับเงิน /ขอสำเนาใบเสร็จรับเงิน' },
          { title: 'ค่าใช้บริการสูงผิดปกติ/ขอตรวจสอบค่าใช้บริการ' },
          { title: 'สมัครบริการ e-service ไม่ได้/ลืม password' },
          { title: 'ชำระเงินผ่านระบบออนไลน์ไม่ได้' },
          { title: 'ชำระเงินแล้ว ยังมียอดค้างชำระ / ยังไม่ต่อสาย' },
          { title: 'แจ้งชำระค่าบริการแล้ว' },
          { title: 'ลูกค้านัดชำระขอให้ต่อสายชั่วคราว' },
          { title: 'ชำระค่าบริการซ้ำ' },
          { title: 'ยกเลิกบริการแล้วแต่ยังได้รับใบแจ้งหนี้' },
          { title: 'ชำระเงินแล้วแต่มีบิลมาเรียกเก็บ' },
          { title: 'ขอรวมบิล / ใบแจ้งค่าใช้บริการ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ร้องเรียนการให้บริการ',
        level_3: [
          { title: 'Call Center' },
          { title: 'ศูนย์บริการ' },
          { title: 'พนักงาน / ช่าง' },
          { title: 'คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ปัญหามิจฉาชีพ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ขอยกเลิกบริการ',
        level_3: [
          { title: 'ยกเลิกคำขอใช้บริการ' },
          { title: 'ยกเลิกการใช้งาน' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แนะนำ/ติชม',
        level_3: [
          { title: 'แนะนำบริการของ NT ให้ลูกค้ารายอื่น' },
          { title: 'แนะนำให้ปรับปรุง บริการ' },
          { title: 'แนะนำให้ปรับปรุง อุปกรณ์' },
          { title: 'แนะนำให้ปรับปรุงบริการอื่นๆ' },
          { title: 'ชมเชย Call Center' },
          { title: 'ชมเชย ศูนย์บริการ' },
          { title: 'ชมเชย พนักงาน / ช่าง' },
          { title: 'ชมเชย คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ชมเชยอื่น ๆ' }
        ]
      }
    ]
  },
  {
    level_1: 'บริการอื่น',
    level_2: [
      {
        title: 'สอบถาม',
        level_3: [
          { title: 'สอบถามอัตราค่าบริการ/ โปรโมชั่น' },
          { title: 'สอบถามพื้นที่ให้บริการ' },
          { title: 'สอบถามเรื่องอุปกรณ์ / การตั้งค่า' },
          { title: 'สอบถามข้อมูลสินค้าและบริการ' },
          { title: 'สอบถามช่องทางสมัครใช้บริการ/จำหน่ายสินค้า' },
          { title: 'สอบถามนัดหมายติดตั้ง' },
          { title: 'สอบถามงานแก้ไขคืนดี' },
          { title: 'สอบถามช่องทางการชำระเงิน' },
          { title: 'สอบถามยอดค้างชำระ/ค่าใช้บริการ/รายละเอียดบิล' },
          { title: 'สอบถามการย้ายค่าย' },
          { title: 'สอบถามข้อมูลองค์กร' },
          { title: 'สอบถามเรื่องอื่น ๆ' }
        ]
      },
      {
        title: 'คำขอบริการ',
        level_3: [
          { title: 'ขอใช้บริการ' },
          { title: 'ขอใบแทนใบเสร็จรับเงิน/ใบกำกับภาษี' },
          { title: 'ขอเปลี่ยนแปลงข้อมูลส่วนบุคคล / นิติบุคคล' },
          { title: 'ขอเปลี่ยนวิธีจัดส่งใบแจ้งหนี้ / e-Bill' },
          { title: 'ระงับการใช้ชั่วคราว' },
          { title: 'ขอยกเลิกการระงับการใช้ชั่วคราว' },
          { title: 'คำขอบริการอื่น ๆ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แจ้งเหตุขัดข้อง',
        level_3: [{ title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }]
      },
      {
        title: 'ใบแจ้งหนี้ / ค่าใช้บริการ',
        level_3: [
          { title: 'ไม่ได้รับใบแจ้งค่าใช้บริการ/ขอสำเนาใบแจ้งค่าใช้บริการ' },
          { title: 'ไม่ได้รับใบเสร็จรับเงิน /ขอสำเนาใบเสร็จรับเงิน' },
          { title: 'ค่าใช้บริการสูงผิดปกติ/ขอตรวจสอบค่าใช้บริการ' },
          { title: 'สมัครบริการ e-service ไม่ได้/ลืม password' },
          { title: 'ชำระเงินผ่านระบบออนไลน์ไม่ได้' },
          { title: 'ชำระเงินแล้ว ยังมียอดค้างชำระ / ยังไม่ต่อสาย' },
          { title: 'แจ้งชำระค่าบริการแล้ว' },
          { title: 'ลูกค้านัดชำระขอให้ต่อสายชั่วคราว' },
          { title: 'ชำระค่าบริการซ้ำ' },
          { title: 'ยกเลิกบริการแล้วแต่ยังได้รับใบแจ้งหนี้' },
          { title: 'ชำระเงินแล้วแต่มีบิลมาเรียกเก็บ' },
          { title: 'ขอรวมบิล / ใบแจ้งค่าใช้บริการ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ร้องเรียนการให้บริการ',
        level_3: [
          { title: 'Call Center' },
          { title: 'ศูนย์บริการ' },
          { title: 'พนักงาน / ช่าง' },
          { title: 'คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ปัญหามิจฉาชีพ' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'ขอยกเลิกบริการ',
        level_3: [
          { title: 'ยกเลิกคำขอใช้บริการ' },
          { title: 'ยกเลิกการใช้งาน' },
          { title: 'แจ้งเลิกรับ e-Newsletter / SMS' },
          { title: 'รอข้อมูลเพิ่มเติมจากลูกค้า' }
        ]
      },
      {
        title: 'แนะนำ/ติชม',
        level_3: [
          { title: 'แนะนำบริการของ NT ให้ลูกค้ารายอื่น' },
          { title: 'แนะนำให้ปรับปรุง บริการ' },
          { title: 'แนะนำให้ปรับปรุง อุปกรณ์' },
          { title: 'แนะนำให้ปรับปรุงบริการอื่นๆ' },
          { title: 'ชมเชย Call Center' },
          { title: 'ชมเชย ศูนย์บริการ' },
          { title: 'ชมเชย พนักงาน / ช่าง' },
          { title: 'ชมเชย คุณภาพผลิตภัณฑ์ / บริการ' },
          { title: 'ชมเชยอื่น ๆ' }
        ]
      }
    ]
  },
  {
    level_1: 'Activity'
  }
]



// WEBPACK FOOTER //
// ./src/constants/nt.js